import { render, staticRenderFns } from "./info.vue?vue&type=template&id=acd4870c&"
import script from "./info.vue?vue&type=script&lang=ts&"
export * from "./info.vue?vue&type=script&lang=ts&"
import style0 from "./info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports